import AdtInfoTitleTable from "./adtInfoTitleTable.container";

export default AdtInfoTitleTable;
